import { BlockOutlined } from '@mui/icons-material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {IconButton, Menu, MenuItem} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import DialogValiderCollab from '../../../Components/Dialogs/DialogValiderCollab';
import useAdminRoleCompanyName from '../../../hooks/useAdminRoleCompanyName';
import usePostRequest from '../../../hooks/usePostRequest';
import { isHttpStatusSuccess } from '../../../Utils/utils';
const EditerCollab = ({rowSelected,getMyCollaborators}) => {
    EditerCollab.propTypes = {
        rowSelected:PropTypes.any,
        getMyCollaborators:PropTypes.func,
    };
    const { postData } = usePostRequest();
    const [openMenu,setOpenMenu]=useState(false);
    const [open,setOpen]=useState(false);
    const [clientRole,companyName]= useAdminRoleCompanyName();
    const { i18n } = useTranslation();
    async function blockUser() {
        try {
            console.log({rowSelected, bool: (rowSelected?.role?.Admin ==0 && rowSelected?.role?.littleAdmin ==0), bool2: (clientRole?.Admin ==1 ||clientRole?.littleAdmin==1)});
            const response = await postData({ url: '/users/blockUser', payload: {
                email: rowSelected?.email_,
                isBlocked: !rowSelected?.isBlocked,
            } });
            if (isHttpStatusSuccess(response?.responseStatus)) {
                Swal.fire({
                    title: i18n.t(response?.data?.message),
                    icon: 'success',
                    confirmButtonColor: '#5CC889',
                    confirmButtonText: 'Ok',
                }).then((result) => {
                    if(result.isConfirmed){
                        getMyCollaborators();
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
        handleCloseMenu();
    }
    console.log('companyName',companyName);
    const handleOpenMenu = () => {
        setOpenMenu(true);
    };

    const handleCloseMenu = () => {
        setOpenMenu(false);
    };

    const handleClickOpen = async () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <>
            <IconButton
                onClick={handleOpenMenu}
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                sx={{ mt: '400px',ml:'-140px' }}
                id="menu-appbar"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorEl={openMenu}
                onClose={handleCloseMenu}
                open={Boolean(openMenu)}

                PaperProps={{
                    style: {
                        width: '150px',
                    },
                }}
            >
                <MenuItem
                    onClick={()=>{
                        console.log('rowSelected',rowSelected,'condition',rowSelected?.statut!='enAttente');
                        handleClickOpen();
                        handleCloseMenu();
                    }}
                    className='B2Style'
                    disabled={((clientRole?.Admin ==1 ||clientRole?.littleAdmin==1) && rowSelected?.statut!='enAttente') ? false : true }
                >
                    {i18n.t('Editer')} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ModeEditOutlinedIcon />
                </MenuItem>
                <MenuItem
                    disabled={(clientRole?.Admin ==1 ||clientRole?.littleAdmin==1) ? false : true }
                    className='B2Style'
                    onClick={handleCloseMenu}
                    hidden
                >
                    {i18n.t('Supprimer')} &nbsp;<DeleteForeverOutlinedIcon />
                </MenuItem>
                <MenuItem
                    disabled={((clientRole?.Admin ==1 ||clientRole?.littleAdmin==1) && (rowSelected?.role?.Admin ==0 && rowSelected?.role?.littleAdmin ==0)) ? false : true }
                    className='B2Style'
                    onClick={blockUser}
                >
                    {rowSelected?.isBlocked ?  i18n.t('Débloquer') : i18n.t('Bloquer') } &nbsp;<BlockOutlined />
                </MenuItem>
            </Menu>
            {open &&
            <DialogValiderCollab
                open={open}
                setOpen={()=>{
                    handleClose();
                    //getMyCollaborators();
                }}
                title={i18n.t('Editer')}
                rowSelected={rowSelected}
                mode={'editer'}
                getMyCollaborators={getMyCollaborators}
            />}
        </>
    );
};

export default EditerCollab;
